document.documentElement.classList.remove('no-js');

(() => {
  const drawer = document.querySelector('[data-mobile-nav]');
  const backdrop = document.querySelector('[data-menu-backdrop]');
  const trigger = document.querySelector('[data-menu-toggle]');
  const closeButton = document.querySelector('[data-menu-close]');
  if (!drawer || !trigger) return;

  const setOpen = (open) => {
    drawer.toggleAttribute('hidden', !open);
    if (backdrop) backdrop.toggleAttribute('hidden', !open);
    trigger.setAttribute('aria-expanded', String(open));
    trigger.setAttribute('aria-label', open ? 'Close menu' : 'Open menu');
    document.body.classList.toggle('menu-is-open', open);
    if (open && closeButton) window.requestAnimationFrame(() => closeButton.focus());
  };

  trigger.addEventListener('click', () => setOpen(drawer.hasAttribute('hidden')));
  if (closeButton) closeButton.addEventListener('click', () => setOpen(false));
  if (backdrop) backdrop.addEventListener('click', () => setOpen(false));
  drawer.addEventListener('click', (event) => {
    if (event.target.closest('a')) setOpen(false);
  });
  document.addEventListener('keydown', (event) => {
    if (event.key === 'Escape' && !drawer.hasAttribute('hidden')) {
      setOpen(false);
      trigger.focus();
    }
  });
})();

// Peach Pop v6 — horizontally scrolling product gallery
(() => {
  document.querySelectorAll('[data-product-gallery]').forEach((gallery) => {
    const track = gallery.querySelector('[data-gallery-track]');
    const slides = Array.from(gallery.querySelectorAll('[data-gallery-slide]'));
    const dots = Array.from(gallery.querySelectorAll('[data-gallery-dot]'));
    const prev = gallery.querySelector('[data-gallery-prev]');
    const next = gallery.querySelector('[data-gallery-next]');
    if (!track || slides.length < 2) return;

    const goTo = (index) => {
      const safeIndex = Math.max(0, Math.min(index, slides.length - 1));
      slides[safeIndex].scrollIntoView({ behavior: 'smooth', block: 'nearest', inline: 'start' });
    };

    const getIndex = () => {
      const width = track.clientWidth || 1;
      return Math.max(0, Math.min(slides.length - 1, Math.round(track.scrollLeft / width)));
    };

    const update = () => {
      const index = getIndex();
      dots.forEach((dot, i) => dot.classList.toggle('is-active', i === index));
      if (prev) prev.disabled = index === 0;
      if (next) next.disabled = index === slides.length - 1;
    };

    if (prev) prev.addEventListener('click', () => goTo(getIndex() - 1));
    if (next) next.addEventListener('click', () => goTo(getIndex() + 1));
    dots.forEach((dot, index) => dot.addEventListener('click', () => goTo(index)));
    track.addEventListener('scroll', () => window.requestAnimationFrame(update), { passive: true });
    window.addEventListener('resize', update, { passive: true });
    update();
  });
})();
